// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + {"5589":"newdetail-fpReady","6496":"newdetail-scoll"}[chunkId] + "." + {"5589":"f86c0577","6496":"4f9739e7"}[chunkId] + ".js";
};